import React from 'react';
import PropTypes from 'prop-types';

import { ReminderName, ReminderScheduleText, ReminderTimePicker, TimeLabel } from './common-reminder-components';

const DueDateReminders = ({ taskReminder, setTaskReminder }) => {

    return (
        <div data-testid="due-date-reminders" >
            <ReminderName taskReminder={taskReminder} setTaskReminder={setTaskReminder} />
            <TimeLabel />
            <ReminderTimePicker taskReminder={taskReminder} setTaskReminder={setTaskReminder} className={"big-element"} />
            <ReminderScheduleText taskReminder={taskReminder} />
        </div>
    );
};

DueDateReminders.propTypes = {
    taskReminder: PropTypes.object.isRequired,
    setTaskReminder: PropTypes.func.isRequired,
};


export default DueDateReminders;